/*
 * Copyright (C) 2021 IHS Markit.
 * All Rights Reserved
 *
 * NOTICE: All information contained herein is, and remains
 * the property of IHS Markit and its suppliers,
 * if any. The intellectual and technical concepts contained
 * herein are proprietary to IHS Markit and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from IHS Markit.
 */
export class Index {
  id: string | undefined;
  indexFamily: string | undefined;
  indexName: string | undefined;
  isinTri: string | undefined;
  bloombergTicker: string | undefined;
  asOf: string | undefined;
  baseDate: string | undefined;
  fixing: string | undefined;
  inflationAdjustment: string | undefined;
  inflationLinked: boolean | undefined;
  totalReturnIndex: string | undefined;
  dailyReturn: string | undefined;
  monthToDateReturn: string | undefined;
  quarterToDateReturn: string | undefined;
  yearToDateReturn: string | undefined;
  yield: string | undefined;
  duration: string | undefined;
  bondsCount: number | undefined;
  region: string | undefined;
  indexCurrency: string | undefined;
  investmentType: string | undefined;
  sector: string | undefined;
  subSector: string | undefined;
  rating: string | undefined;
  ratingCategory: string | undefined;
  maturity: string | undefined;
  redId: string | undefined;
  fxVersion: string | undefined;
}
